import React, { useCallback, useState } from 'react'
import Select from 'react-select'
import { find, first } from 'lodash'

const ColumnSelector = ({
    records = [],
    values = [],
    onChange = () => {},
}) => {

    //const [selections, setSelections] = useState([])
    let options = []
    const record = first(records)
    if (record) {
        options = record.map((column, index) => ({ value: index, label: column }))
    }

    const selections = values.filter(i => find(options, { value: i })).map(i => find(options, { value: i }))

    const onSelectionChange = useCallback(values => {
        onChange(values.map(v => v.value))
    }, [onChange])

    return (
        <Select
            value={selections}
            isMulti
            name="colors"
            options={options}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onSelectionChange}
            placeholder='Select Columns'
        />
    )
}

export default ColumnSelector